var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import DOMPurify from 'dompurify';
import { getFormattedToSlashFormat } from '@lean-body/src/util';
import { makeObservable, observable } from 'mobx';
export const tvAnnoucementId = (config) => {
    return config.isProduction ? 320 : 425;
};
export class AnnouncementService {
    constructor(apiClient, config) {
        Object.defineProperty(this, "apiClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "unreadAnnouncementCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.apiClient = apiClient;
        this.config = config;
    }
    getUnreadAnnounecmentCount() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.unreadAnnouncementCount) {
                const res = yield this.apiClient.getUnreadAnnouncementCount();
                this.unreadAnnouncementCount = new UnreadAnnouncementCount(res);
            }
            return this.unreadAnnouncementCount;
        });
    }
}
export class Announcements {
    constructor(announcementsData, config) {
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "announcements", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lastPage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.announcements = announcementsData.announcements.filter((v) => v).map((v) => new Announcement(v, config));
        this.lastPage = announcementsData.lastPage;
        this.config = config;
    }
}
export class Announcement {
    constructor(announcementData, config) {
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "body", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "publishAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "formattedPublishAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "thumbnailSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isRead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = announcementData.id;
        this.title = announcementData.title;
        this.body = this.parseMarkdown(announcementData.body);
        this.formattedPublishAt = announcementData.publishAt && getFormattedToSlashFormat(announcementData.publishAt);
        this.thumbnailSrc = config.cdnBaseURL + announcementData.thumbnailSrc;
        this.isRead = announcementData.isRead;
        this.config = config;
    }
    get isNew() {
        return !this.isRead;
    }
    parseMarkdown(body) {
        // タグの末尾の改行を取り除く
        body = body.replace(/(<h1.*\/h1>)(\r\n)/g, '$1');
        body = body.replace(/(<h2.*\/h2>)(\r\n)/g, '$1');
        body = body.replace(/(<br.*\/br>)(\r\n)/g, '$1');
        body = body.replace(/(<a.*\/a>)(\r\n)/g, '$1');
        body = body.replace(/(<span.*\/span>)(\r\n)/g, '$1');
        DOMPurify.addHook('afterSanitizeAttributes', (node) => {
            if (node.tagName && node.tagName.toLowerCase() === 'iframe') {
                const src = node.getAttribute('src');
                if (src && !src.includes('www.youtube.com')) {
                    node.removeAttribute('src');
                }
            }
        });
        return DOMPurify.sanitize(body, {
            ADD_TAGS: ['iframe'],
            ADD_ATTR: ['width', 'height', 'src', 'title', 'frameborder', 'allow', 'referrerpolicy', 'allowfullscreen'],
        });
    }
}
export class UnreadAnnouncementCount {
    constructor(unreadAnnouncementCountData) {
        Object.defineProperty(this, "count", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeObservable(this, {
            count: observable,
        });
        this.count = unreadAnnouncementCountData.unreadAnnouncementCount;
    }
    get moreThanZero() {
        return this.count > 0;
    }
    substructCount() {
        if (this.moreThanZero)
            this.count--;
    }
    changeToZero() {
        this.count = 0;
    }
}
